<template>
    <page-title
        title="実施題材選択"
        icon="bi-bricks"
        :title_sub_1="is_muji ? '無地' : ''"
        :backTo="{ name: 'PageRepocraftSubjectAdd' }"
    >
    </page-title>

  <summary-box title="対象">
    <summary-box-row title="" :text="Grade.getGradeValue(parseInt($route.params.grade, 10)) + ' (' + parseInt($route.params.year, 10) + '年度) '"></summary-box-row>
  </summary-box>

  <div class="d-flex flex-wrap gap-2 align-items-end my-3">
    <div class="form-group col-7 col-md-4">
      <label class="form-label">年度</label>
      <form-select
          v-model="condition.year"
          :options="storeSchoolYears()"
          empty_option="-- 選択 --"
          @change="onChangeYear"
          :disabled="condition_disabled"
      ></form-select>
    </div>
    <div class="form-group col-7 col-md-4">
      <label class="form-label">学年</label>
      <select v-model="condition.grade" class="form-select" :disabled="condition_disabled" @change="onChangeGrade">
        <option :value="null" selected>-- 選択 --</option>
        <template v-if="condition.year">
          <template v-for="(grade, index) in storeSchoolYearGrades()[condition.year]" :key="index">
            <option :value="grade.key">{{ grade.label }}</option>
          </template>
        </template>
      </select>
    </div>
  </div>

  <inline-loader v-if="section_loading"></inline-loader>
  <div v-else>
    <template v-if="planned_subjects.length">
      <table-normal>
        <colgroup>
          <col class="col-4">
          <col class="col-3">
          <col class="col-14">
          <col class="col-3">
        </colgroup>
        <thead>
        <tr>
          <th>学期</th>
          <th>授業開始時期</th>
          <th>実施題材名</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(subject, index) in planned_subjects"
            :key="index"
        >
          <td class="text-center">{{ Term.get(subject.term) }}</td>
          <td class="text-center">{{ $helper.dmp(subject.lesson_from) }}</td>
          <td>{{ subject.subject_name }}</td>
          <td class="d-flex justify-content-between align-items-center">
            <button-dom-show
                text="選択"
                icon="bi-window"
                @click="openModal(index)"
            ></button-dom-show>
            <template v-if="having_subjects.some( s => s.planned_subject_id === subject.template_subject_id)">
              <div class="ms-2 text-danger">登録済</div>
            </template>
          </td>
        </tr>
        </tbody>
      </table-normal>
    </template>
    <alert-no-record v-else text="登録がありません"></alert-no-record>
  </div>

    <!-- 年間計画に入れる題材・編集モーダル -->
    <div v-if="modal_shown">
        <transition name="fade">
            <div class="modal_inner">
                <div class="modal-backdrop show"></div>
                <div class="modal" tabindex="-1" style="display:block">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <!-- modal head -->
                            <div class="modal-header">
                                <h4 class="modal-title">年間計画に入れる題材</h4>
                                <button type="button" class="btn-close" @click="closeModal"></button>
                            </div>
                            <!-- modal body -->
                            <div class="modal-body">
                                <inline-loader v-if="modal_loading"></inline-loader>
                                <form @submit.prevent="save()" v-else>
                                    <div class="row">
                                        <div class="col-20">
                                            <label class="form-label">題材名</label>
                                            <form-input
                                                v-model="new_planned_subject.subject_name"
                                                :required="true"
                                            ></form-input>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-13 col-md-10">
                                            <label class="form-label">学期</label>
                                            <form-select
                                                v-model="new_planned_subject.term"
                                                :options="terms"
                                                empty_option="--選択--"
                                                :required=true
                                                @change="onChangeModalTerm"
                                            ></form-select>
                                            <label class="form-label">開始時期</label>
                                            <form-select
                                                v-model="new_planned_subject.lesson_from"
                                                :options="lesson_froms"
                                                :required=true
                                                model_type="string"
                                            ></form-select>
                                            <!-- input-groupにする -->
                                        </div>
                                    </div>

                                    <button-wrap optional_class="mt-5 mb-5">
                                        <template v-slot:default>
                                            <button-exec-edit text="登録"></button-exec-edit>
                                        </template>
                                    </button-wrap>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import LessonFromOptions from '@/shared/models/services/lesson-from-options.js';
import PlannedSubject from '@/shared/models/entities/repocraft/planned-subject';
import Grade from '@/shared/models/enums/grade'
import Term from '@/shared/models/enums/term'
import PageTitle from '@/shared/components/design/PageTitle';
import AlertNoRecord from '@/shared/components/design/AlertNoRecord';
import SummaryBox from '@/shared/components/design/SummaryBox';
import SummaryBoxRow from '@/shared/components/design/SummaryBoxRow';
import TableNormal from '@/shared/components/design/TableNormal';
import ButtonDomShow from '@/shared/components/design/buttons/ButtonDomShow';
import ButtonExecEdit from '@/shared/components/design/buttons/ButtonExecEdit';
import ButtonWrap from '@/shared/components/design/buttons/ButtonWrap';
import FormInput from '@/shared/components/form/FormInput';
import FormSelect from '@/shared/components/form/FormSelect';
import InlineLoader from '@/shared/components/tool/InlineLoader';

export default {
    name: 'PageRepocraftPastSubjectAdd',
    components: {
        PageTitle,
        AlertNoRecord,
        SummaryBox,
        SummaryBoxRow,
        TableNormal,
        ButtonDomShow,
        ButtonExecEdit,
        ButtonWrap,
        FormInput,
        FormSelect,
        InlineLoader
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            is_muji: this.$route.meta?.is_muji ?? false, // レポクラフト無地判定
            app_key: this.$route.meta?.is_muji ? 'repocraft_muji' : 'repocraft', //アプリ名取得

            having_subjects: [],
            planned_subjects: [],
            new_planned_subject: new PlannedSubject(),

            condition: {
                year: null,
                grade: null,
            },
            condition_disabled: false,

            //entity
            Grade,
            Term,

            //モーダル用選択肢
            terms: Term.optionsFor(this.$store.state.school.auth.school.term_pattern),
            lesson_froms: LessonFromOptions.generate(parseInt(this.$route.params.year, 10)),

            modal_shown: false,
            loading: false,
            section_loading: false,
            modal_loading: false,
        }
    },
    computed: {
        //セッションから取得（レポクラフト/レポクラフト無地 切り替えを動的に）
        storeSchoolYearGrades() {
            return () => this.$store.state.school[this.app_key + '_year_grade'].year_grades;
        },
        storeSchoolYears() {
            return () => this.$store.state.school[this.app_key + '_year_grade'].years;
        },
        storeSchoolYear() {
            return () => this.$store.state.school[this.app_key + '_year_grade'].year;
        },
        storeSchoolGrade() {
            return () => this.$store.state.school[this.app_key + '_year_grade'].grade;
        },
    },
    mounted() {
        this.section_loading = true;
        //年度・学年の選択肢取得
        this.$store.dispatch(`school/${this.app_key}_year_grade/makeOptions`)
        .then(() => {
            //sessionから補完
            this.condition.year = this.storeSchoolYear();
            this.condition.grade = this.storeSchoolGrade();
        })
        .finally(() => {
            this.section_loading = false;

            this.fetchPlannedSubjects();
        });
    },
    methods: {
        // 年度の変更時
        onChangeYear() {
            this.condition.grade = null; //gradeリセット
            this.planned_subjects = []; //初期化
        },

        //  学年の変更時
        onChangeGrade() {
            this.fetchPlannedSubjects();
        },

        //実施題材一覧を取得
        fetchPlannedSubjects() {
            this.section_loading = true;
            this.planned_subjects = []; //初期化
            this.$http.get(`/school/repocraft/year/${this.condition.year}/grade/${this.condition.grade}/subject`)
            .then(response => {
                for (let subject of response.data) {
                    this.planned_subjects.push(new PlannedSubject(subject));
                }
            })
            .finally(() => {
                this.section_loading = false;
            });
        },

        // 題材登録時
        save() {
            this.modal_loading = true;
            this.$http.post(
                `/school/repocraft/year/${parseInt(String(this.$route.params.year), 10)}/grade/${parseInt(String(this.$route.params.grade), 10)}/subject/copy`,
                this.new_planned_subject,
            )
            .then(response => {
                let new_subject = new PlannedSubject(response.data);
                this.modal_shown = false;
                //リダイレクト
                this.$router.push({
                    name: 'PageRepocraftSubjectEdit',
                    params: {
                        year: parseInt(String(this.$route.params.year), 10),
                        grade: parseInt(String(this.$route.params.grade), 10),
                        subject_id: new_subject.planned_subject_id,
                    },
                });
            })
            .finally(() => {
            this.modal_loading = false;
            this.closeModal();
            });
        },

        //登録モーダルオープン
        openModal(index) {
            this.new_planned_subject = new PlannedSubject();
            this.new_planned_subject.planned_subject_id = this.planned_subjects[index].planned_subject_id;
            this.new_planned_subject.template_subject_id = this.planned_subjects[index].template_subject_id;
            this.new_planned_subject.subject_name = this.planned_subjects[index].subject_name;
            this.new_planned_subject.term = this.planned_subjects[index].term;

            // planned_subjects には過去の年のものが入ってくるため，これを今年に変更しなければならない．
            const date = new Date(this.planned_subjects[index].lesson_from);
            date.setFullYear(parseInt(String(this.$route.params.year), 10));
            this.new_planned_subject.lesson_from = date
                .toLocaleDateString("ja-JP", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .split("/")
                .join("-");

            this.modal_shown = true;
        },
        //登録モーダル閉じる
        closeModal() {
            this.modal_shown = false;
        },
        //モーダルの学期選択 変更時
        onChangeModalTerm() {
            this.new_planned_subject.lesson_from = null; //一旦リセット
        },
    },
}
</script>

<style scoped>
    .nav-pills .nav-link {border: 1px solid #dee2e6; border-bottom: none;}
    .nav-pills .nav-link.active{border: none;}
</style>
<style>
    .title-sub-1 {border-color: #198754 !important;}
</style>
